import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)
export default new Vuex.Store({
  //state存放状态,
  state: {
    laoutLoading: false,//全局loading
  },
  //getter为state的计算属性
  getters: {
    getLoadingStatus: (state) => state.laoutLoading,//获取全局loading
  },
  //mutations可更改状态的逻辑，同步操作
  mutations: {
    setLaoutLoading: (state, data) => state.laoutLoading = data,
  },
  //提交mutation，异步操作
  actions: {
    acSetName(context, val) {
      setTimeout(() => {
        //延时1秒提交至mutations中的方法
        context.commit("setLaoutLoading",val );
      }, 100);
    },
  },
  // 将store模块化
  modules: {
  }
})